export default __webpack_public_path__ + "static/media/ic-cloudy.9857459a.svg";